module.exports = __webpack_public_path__ + "media/images/fb-signin-04824d4f7c35537d28f138c395686fafb5428c2c96266e19e52c5dd89d6066be.png";